import { IStation } from '@helpers/types';
import { useCallback, useEffect, useState } from 'react';
import { useHttp } from '@hooks/use-http';

interface IQrModal {
  qr: string;
  pdf?: string;
  station: IStation;
}

const useQrModal = (props: IQrModal) => {
  const http = useHttp();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(undefined);

  const handlePdf = useCallback(async () => {
    http.induction.queryContainersRest(
      props.station.country,
      props.station.station,
      true,
    ).then((res: any) => {
      window.open(
        res?.data?.containersDynamic?.pdfUrl,
        '_blank',
        'noopener,noreferrer',
      );
    });
  }, [props, http]);

  const handleClose = () => setOpen(false);
  const handleShow = () => setOpen(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await http.induction.getContainer(props.qr);
      setData({ container: res });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [props.qr, http]);

  const toggle = useCallback(
    async (status: boolean) => {
      await http.induction.toggleContainer(props.qr, status);
      await load();
    },
    [load, props.qr, http],
  );

  useEffect(() => {
    if (open) load();
  }, [open, load]);

  return {
    open,
    data,
    toggle,
    loading,
    handlePdf,
    handleClose,
    handleShow,
  };
};

export default useQrModal;
